import { Sparkles } from "lucide-react";
import CallbackForm from "./CallbackForm";

export default function FinalCTA() {
  return (
    <section
      id="final-cta"
      className="py-16 lg:py-24 bg-white"
      data-testid="final-cta-section"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-brand-blue text-white p-8 sm:p-12 lg:p-16">
          <div
            aria-hidden="true"
            className="absolute -top-24 -right-24 h-80 w-80 rounded-full bg-brand-yellow/30 blur-3xl"
          />
          <div
            aria-hidden="true"
            className="absolute bottom-0 right-0 h-40 w-40 rounded-full bg-brand-yellow/15 blur-2xl"
          />

          <div className="relative max-w-2xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur-sm px-3 py-1.5 text-xs font-bold uppercase tracking-wider">
              <Sparkles className="h-3.5 w-3.5" />
              Bezpłatna wycena · 5–10 minut
            </div>
            <h2 className="mt-4 font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
              Chcesz poznać koszt instalacji PV?
            </h2>
            <p className="mt-4 text-lg text-white/80">
              Zostaw numer — oddzwonimy w ciągu <strong className="text-white">5–10 minut</strong>.
            </p>

            <div className="mt-7 max-w-md mx-auto">
              <CallbackForm
                source="Final"
                ctaLabel="Chcę bezpłatną wycenę"
                helperText="Bez spamu · Bez zobowiązań · Bez nacisku"
                inputId="final-phone"
                testIdPrefix="final-callback"
                variant="onDark"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
